/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import { GridContext as o } from "../GridClientWrapper.mjs";
const n = (e) => {
  const r = t.useContext(o);
  return /* @__PURE__ */ t.createElement("div", { style: e.isVirtualScroll ? { height: r.vsRef.current.containerHeight + "px" } : {} });
};
export {
  n as VirtualScrollHeightContainer
};
